/**
 * Gera e faz download de um template Excel para importação
 */
export const downloadTemplate = async (mapType: string = 'OFFICE'): Promise<void> => {
  try {
    // Importar XLSX dinamicamente
    const XLSX = await import('xlsx');
    const { utils, writeFile } = XLSX;
    const workbook = utils.book_new();

    if (String(mapType).toUpperCase() === 'FACTORY') {
      const factoryRows = [
        {
          Tipo: 'Cliente',
          Nome: 'Cliente',
          Demanda_Dia: 920,
          Produto: 'Produto A',
          CT: '',
          Unidade_CT: '',
          Operadores: '',
          Disponibilidade: '',
          Estoque_Unidades: '',
          Estoque_Dias: '',
          Observacoes: 'Demanda diária do cliente final',
        },
        {
          Tipo: 'Fornecedor',
          Nome: 'Fornecedor',
          Demanda_Dia: '',
          Produto: 'Materia prima',
          CT: '',
          Unidade_CT: '',
          Operadores: '',
          Disponibilidade: '',
          Estoque_Unidades: '',
          Estoque_Dias: '',
          Observacoes: 'Fornecedor principal',
        },
        {
          Tipo: 'PCPM',
          Nome: 'PCPM',
          Demanda_Dia: '',
          Produto: '',
          CT: '',
          Unidade_CT: '',
          Operadores: '',
          Disponibilidade: '',
          Estoque_Unidades: '',
          Estoque_Dias: '',
          Observacoes: 'Controle de produção e materiais',
        },
        {
          Tipo: 'Processo',
          Nome: 'Estamparia',
          Demanda_Dia: '',
          Produto: '',
          CT: 15,
          Unidade_CT: 'seg',
          Operadores: 1,
          Disponibilidade: 95,
          Estoque_Unidades: 2800,
          Estoque_Dias: '',
          Observacoes: 'Primeira operação do fluxo',
        },
        {
          Tipo: 'Processo',
          Nome: 'Solda I',
          Demanda_Dia: '',
          Produto: '',
          CT: 39,
          Unidade_CT: 'seg',
          Operadores: 1,
          Disponibilidade: 94,
          Estoque_Unidades: 4600,
          Estoque_Dias: '',
          Observacoes: '',
        },
        {
          Tipo: 'Processo',
          Nome: 'Solda II',
          Demanda_Dia: '',
          Produto: '',
          CT: 46,
          Unidade_CT: 'seg',
          Operadores: 1,
          Disponibilidade: 94,
          Estoque_Unidades: 4100,
          Estoque_Dias: '',
          Observacoes: '',
        },
        {
          Tipo: 'Processo',
          Nome: 'Montagem',
          Demanda_Dia: '',
          Produto: '',
          CT: 62,
          Unidade_CT: 'seg',
          Operadores: 2,
          Disponibilidade: 92,
          Estoque_Unidades: 2500,
          Estoque_Dias: '',
          Observacoes: 'Exemplo de gargalo se CT > takt',
        },
        {
          Tipo: 'Processo',
          Nome: 'Expedicao',
          Demanda_Dia: '',
          Produto: '',
          CT: 22,
          Unidade_CT: 'seg',
          Operadores: 1,
          Disponibilidade: 97,
          Estoque_Unidades: 0,
          Estoque_Dias: '',
          Observacoes: 'Ultima etapa antes do cliente',
        },
      ];

      const factorySheet = utils.json_to_sheet(factoryRows);
      factorySheet['!cols'] = [
        { wch: 14 },
        { wch: 24 },
        { wch: 14 },
        { wch: 18 },
        { wch: 10 },
        { wch: 12 },
        { wch: 12 },
        { wch: 16 },
        { wch: 18 },
        { wch: 14 },
        { wch: 38 },
      ];

      const factoryInstructions = [
        { A: 'TEMPLATE FACTORY VSM - IMPORTACAO SIMPLES', B: '', C: '', D: '' },
        { A: '', B: '', C: '', D: '' },
        { A: 'Como usar', B: 'Preencha apenas a aba Dados e importe pelo menu Arquivo > Importar Excel.', C: '', D: '' },
        { A: 'Tipo', B: 'Use Cliente, Fornecedor, PCPM ou Processo.', C: '', D: '' },
        { A: 'Nome', B: 'Nome que aparecera no card.', C: '', D: '' },
        { A: 'Demanda_Dia', B: 'Obrigatorio no Cliente. Exemplo: 920 pecas/dia.', C: '', D: '' },
        { A: 'CT', B: 'Tempo de ciclo do processo. Use Unidade_CT para informar seg, min ou h.', C: '', D: '' },
        { A: 'Operadores', B: 'Quantidade de operadores no processo.', C: '', D: '' },
        { A: 'Disponibilidade', B: 'Percentual de disponibilidade/OEE basico. Exemplo: 95.', C: '', D: '' },
        { A: 'Estoque_Unidades', B: 'Quantidade em estoque antes do processo. O sistema calcula dias usando Demanda_Dia.', C: '', D: '' },
        { A: 'Estoque_Dias', B: 'Opcional. Se preenchido, substitui o calculo por unidades/demanda.', C: '', D: '' },
        { A: '', B: '', C: '', D: '' },
        { A: 'Dica', B: 'Mantenha a ordem dos processos de esquerda para direita. O importador cria o fluxo automaticamente.', C: '', D: '' },
      ];
      const instructionsSheet = utils.json_to_sheet(factoryInstructions, { skipHeader: true });
      instructionsSheet['!cols'] = [{ wch: 28 }, { wch: 90 }, { wch: 12 }, { wch: 12 }];

      utils.book_append_sheet(workbook, factorySheet, 'Dados');
      utils.book_append_sheet(workbook, instructionsSheet, 'Instrucoes');
      writeFile(workbook, `Template_Factory_VSM_${new Date().toISOString().split('T')[0]}.xlsx`);
      return;
    }

    // Dados do template com exemplos e instruções
    const templateData = [
      {
        Tipo: 'Início',
        Atividade: 'Início do Processo',
        Setor: 'Sistema',
        Quem: 'Sistema',
        Como: 'Automático',
        P: 1,
        TP: 0,
        TRA: 0,
        Pai: '',
        Condição: '',
        Nota1: '[D] Dado inicial do processo',
        Nota2: '',
        Nota3: '',
        Nota4: '',
        Nota5: '',
        Nota6: '',
        Nota7: '',
        Nota8: '',
        Nota9: '',
        Nota10: ''
      },
      {
        Tipo: 'Processo',
        Atividade: 'Exemplo de Atividade',
        Setor: 'Comercial',
        Quem: 'Nome do Responsável',
        Como: 'Sistema Utilizado',
        P: 1,
        TP: 60,
        TRA: 30,
        Pai: 'Início do Processo',
        Condição: '',
        Nota1: '[P] Problema identificado',
        Nota2: '[A] Ação necessária',
        Nota3: '[I] Ideia de melhoria',
        Nota4: '[D] Dado adicional',
        Nota5: '',
        Nota6: '',
        Nota7: '',
        Nota8: '',
        Nota9: '',
        Nota10: ''
      },
      {
        Tipo: 'Decisão',
        Atividade: 'Exemplo de Decisão',
        Setor: 'Gerência',
        Quem: 'Gestor',
        Como: 'Análise Manual',
        P: 1,
        TP: 15,
        TRA: 5,
        Pai: 'Exemplo de Atividade',
        Condição: 'Sim',
        Nota1: '[D] Critério de decisão',
        Nota2: '',
        Nota3: '',
        Nota4: '',
        Nota5: '',
        Nota6: '',
        Nota7: '',
        Nota8: '',
        Nota9: '',
        Nota10: ''
      }
    ];

    // Criar worksheet de dados
    const worksheet = utils.json_to_sheet(templateData);
    // Criar worksheet de instruções detalhadas
    const instructions = [
      { A: '═══════════════════════════════════════════════════════════════', B: '', C: '', D: '', E: '' },
      { A: 'TEMPLATE DE IMPORTAÇÃO - MAPA DE FLUXO DE VALOR (VSM)', B: '', C: '', D: '', E: '' },
      { A: '═══════════════════════════════════════════════════════════════', B: '', C: '', D: '', E: '' },
      { A: '', B: '', C: '', D: '', E: '' },
      { A: '📋 INSTRUÇÕES DE USO:', B: '', C: '', D: '', E: '' },
      { A: '', B: '', C: '', D: '', E: '' },
      { A: '1. Preencha a aba "Dados" com as atividades do seu processo', B: '', C: '', D: '', E: '' },
      { A: '2. Use os exemplos como referência para o formato correto', B: '', C: '', D: '', E: '' },
      { A: '3. Não altere os nomes das colunas', B: '', C: '', D: '', E: '' },
      { A: '4. Após preencher, importe o arquivo pela opção "Importar Excel"', B: '', C: '', D: '', E: '' },
      { A: '5. O sistema criará automaticamente o mapa de fluxo de valor', B: '', C: '', D: '', E: '' },
      { A: '', B: '', C: '', D: '', E: '' },
      { A: '═══════════════════════════════════════════════════════════════', B: '', C: '', D: '', E: '' },
      { A: '📊 DESCRIÇÃO DOS CAMPOS:', B: '', C: '', D: '', E: '' },
      { A: '═══════════════════════════════════════════════════════════════', B: '', C: '', D: '', E: '' },
      { A: '', B: '', C: '', D: '', E: '' },
      { A: 'CAMPO', B: 'TIPO', C: 'OBRIGATÓRIO', D: 'DESCRIÇÃO', E: 'EXEMPLO' },
      { A: '─────────────────', B: '─────────', C: '────────────', D: '──────────────────────────────────────────', E: '─────────────────────────────' },
      { A: 'Tipo', B: 'Texto', C: 'SIM', D: 'Tipo do card: Início, Processo, Decisão ou Fim', E: 'Processo' },
      { A: 'Atividade', B: 'Texto', C: 'SIM', D: 'Nome da atividade ou pergunta (para decisões)', E: 'Analisar Solicitação' },
      { A: 'Setor', B: 'Texto', C: 'NÃO', D: 'Setor ou departamento responsável', E: 'Comercial' },
      { A: 'Quem', B: 'Texto', C: 'NÃO', D: 'Responsável pela execução da atividade', E: 'Equipe de Análise' },
      { A: 'Como', B: 'Texto', C: 'NÃO', D: 'Sistema, ferramenta ou método utilizado', E: 'Sistema ERP' },
      { A: 'P', B: 'Número', C: 'NÃO', D: 'Quantidade de pessoas trabalhando simultaneamente', E: '1' },
      { A: 'TP', B: 'Número', C: 'NÃO', D: 'Tempo de Permanência (Lead Time) em minutos', E: '60' },
      { A: 'TRA', B: 'Número', C: 'NÃO', D: 'Tempo de Realização da Atividade (Touch Time) em minutos', E: '30' },
      { A: 'Pai', B: 'Texto', C: 'NÃO', D: 'Nome da atividade anterior (para criar conexões)', E: 'Início do Processo' },
      { A: 'Condição', B: 'Texto', C: 'NÃO', D: 'Para decisões: "Sim" ou "Não" (define o ramo)', E: 'Sim' },
      { A: 'Nota1', B: 'Texto', C: 'NÃO', D: 'Post-it tipo [P] Problema, [A] Ação, [I] Ideia, [D] Dado', E: '[P] Demora na resposta' },
      { A: 'Nota2', B: 'Texto', C: 'NÃO', D: 'Post-it tipo [P] Problema, [A] Ação, [I] Ideia, [D] Dado', E: '[A] Automatizar processo' },
      { A: 'Nota3 a Nota10', B: 'Texto', C: 'NÃO', D: 'Campos adicionais para mais post-its', E: '[I] Usar IA para triagem' },
      { A: '', B: '', C: '', D: '', E: '' },
      { A: '═══════════════════════════════════════════════════════════════', B: '', C: '', D: '', E: '' },
      { A: '🔤 TIPOS DE CARD VÁLIDOS:', B: '', C: '', D: '', E: '' },
      { A: '═══════════════════════════════════════════════════════════════', B: '', C: '', D: '', E: '' },
      { A: '', B: '', C: '', D: '', E: '' },
      { A: '• Início', B: '→', C: 'Card inicial do processo (deve haver apenas um)', D: '', E: '' },
      { A: '• Processo', B: '→', C: 'Atividade do fluxo de trabalho', D: '', E: '' },
      { A: '• Decisão', B: '→', C: 'Ponto de decisão com ramificações Sim/Não', D: '', E: '' },
      { A: '• Fim', B: '→', C: 'Finalização do processo', D: '', E: '' },
      { A: '', B: '', C: '', D: '', E: '' },
      { A: '═══════════════════════════════════════════════════════════════', B: '', C: '', D: '', E: '' },
      { A: '📝 TIPOS DE POST-IT (NOTAS):', B: '', C: '', D: '', E: '' },
      { A: '═══════════════════════════════════════════════════════════════', B: '', C: '', D: '', E: '' },
      { A: '', B: '', C: '', D: '', E: '' },
      { A: 'Use os prefixos abaixo no início do texto da nota:', B: '', C: '', D: '', E: '' },
      { A: '', B: '', C: '', D: '', E: '' },
      { A: '[P]', B: '→', C: 'Problema identificado na atividade', D: '', E: '[P] Alto tempo de espera' },
      { A: '[A]', B: '→', C: 'Ação ou melhoria a ser implementada', D: '', E: '[A] Criar fila prioritária' },
      { A: '[I]', B: '→', C: 'Ideia para otimização ou inovação', D: '', E: '[I] Usar sistema de agendamento' },
      { A: '[D]', B: '→', C: 'Dado ou informação relevante', D: '', E: '[D] 80% dos casos são simples' },
      { A: '', B: '', C: '', D: '', E: '' },
      { A: '═══════════════════════════════════════════════════════════════', B: '', C: '', D: '', E: '' },
      { A: '⚠️ OBSERVAÇÕES IMPORTANTES:', B: '', C: '', D: '', E: '' },
      { A: '═══════════════════════════════════════════════════════════════', B: '', C: '', D: '', E: '' },
      { A: '', B: '', C: '', D: '', E: '' },
      { A: '• O campo "Tipo" é obrigatório e deve ser exatamente um dos valores válidos', B: '', C: '', D: '', E: '' },
      { A: '• O campo "Atividade" é obrigatório e será usado como identificador', B: '', C: '', D: '', E: '' },
      { A: '• O campo "Pai" cria a conexão entre cards (deve ser o nome exato de outra atividade)', B: '', C: '', D: '', E: '' },
      { A: '• Para cards de tipo "Decisão", use o campo "Condição" com "Sim" ou "Não"', B: '', C: '', D: '', E: '' },
      { A: '• Tempos TP e TRA devem estar em minutos (use 0 se não houver)', B: '', C: '', D: '', E: '' },
      { A: '• Quantidade P (pessoas) padrão é 1 se não for especificado', B: '', C: '', D: '', E: '' },
      { A: '• Notas sem prefixo [P], [A], [I] ou [D] serão classificadas como [D] Dado', B: '', C: '', D: '', E: '' },
      { A: '• Linhas vazias ou com campos obrigatórios faltando serão ignoradas', B: '', C: '', D: '', E: '' },
      { A: '', B: '', C: '', D: '', E: '' },
      { A: '═══════════════════════════════════════════════════════════════', B: '', C: '', D: '', E: '' },
      { A: '💡 DICA: Comece sempre com um card "Início" e termine com um "Fim"', B: '', C: '', D: '', E: '' },
      { A: '═══════════════════════════════════════════════════════════════', B: '', C: '', D: '', E: '' },
      { A: '', B: '', C: '', D: '', E: '' },
      { A: '📞 Suporte: Para dúvidas, consulte a documentação do sistema', B: '', C: '', D: '', E: '' },
      { A: '═══════════════════════════════════════════════════════════════', B: '', C: '', D: '', E: '' },
    ];

    const instructionsSheet = utils.json_to_sheet(instructions, { skipHeader: true });
    
    // Ajustar largura das colunas da aba de instruções
    instructionsSheet['!cols'] = [
      { wch: 70 },  // Coluna A - texto principal
      { wch: 5 },   // Coluna B - seta
      { wch: 15 },  // Coluna C
      { wch: 45 },  // Coluna D - descrição
      { wch: 30 }   // Coluna E - exemplo
    ];

    // Adicionar worksheets ao workbook. Dados precisa ser a primeira aba porque o importador usa essa aba por padrão.
    utils.book_append_sheet(workbook, worksheet, 'Dados');
    utils.book_append_sheet(workbook, instructionsSheet, 'Instruções');

    // Ajustar largura das colunas
    const colWidths = [
      { wch: 15 }, // Tipo
      { wch: 30 }, // Atividade
      { wch: 20 }, // Setor
      { wch: 20 }, // Quem
      { wch: 20 }, // Como
      { wch: 5 },  // P
      { wch: 8 },  // TP
      { wch: 8 },  // TRA
      { wch: 25 }, // Pai
      { wch: 10 }, // Condição
      { wch: 30 }, // Nota1-10 (10 colunas)
      { wch: 30 },
      { wch: 30 },
      { wch: 30 },
      { wch: 30 },
      { wch: 30 },
      { wch: 30 },
      { wch: 30 },
      { wch: 30 },
      { wch: 30 },
      { wch: 30 },
    ];
    worksheet['!cols'] = colWidths;

    // Fazer download
    const fileName = `Template_Importacao_Workflow_${new Date().toISOString().split('T')[0]}.xlsx`;
    writeFile(workbook, fileName);
  } catch (error) {
    console.error('Erro ao gerar template:', error);
    throw new Error('Falha ao gerar template. Tente novamente.');
  }
};
